import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

export default function Register() {
  const [form, setForm] = useState({
    name: '',
    phone: '',
    email: '',
    password: ''
  });
  
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  // --- LÓGICA DE PROTECCIÓN DE ADMINISTRADOR ---
  // Detectamos si estamos en admin.localhost o similar
  const host = window.location.hostname;
  let isSystemAdminHost = window.location.hostname.startsWith('admin.');

  /* DESCOMENTAR LA SIGUIENTE LÍNEA PARA PERMITIR REGISTRO EN ADMIN 
     (Solo cuando necesites crear un admin nuevo, luego vuelve a comentarla)
  */
 
  //isSystemAdminHost = false; 
 

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    if (isLoading) return;
    setIsLoading(true);

    try {
      await api.post('/users/register', form);
      navigate('/confirm', { state: { email: form.email } });
    } catch (err) {
      const errorMsg = err.response?.data?.message || err.message;
      if (errorMsg.includes('no confirmado')) {
        alert('⚠️ Ya existe una cuenta con este correo pero no está confirmada.');
        navigate('/confirm', { state: { email: form.email } });
      } else {
        alert('❌ ' + errorMsg);
      }
    } finally {
      setIsLoading(false);
    }
  };

  // Si es el host de admin, mostramos un mensaje de bloqueo en lugar del formulario
  if (isSystemAdminHost) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-slate-900 text-white p-6">
        <div className="bg-white text-gray-800 p-10 rounded-2xl shadow-2xl max-w-md text-center">
          <div className="bg-red-100 text-red-600 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m0 0v2m0-2h2m-2 0H10m11-3V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2h14a2 2 0 002-2zm-10 0V7a3 3 0 00-3-3H6a3 3 0 00-3 3v8h7z" />
            </svg>
          </div>
          <h2 className="text-2xl font-black mb-2 uppercase">Acceso Restringido</h2>
          <p className="text-gray-600 mb-6">
            El registro público está deshabilitado para el panel de administración por seguridad.
          </p>
          <button 
            onClick={() => navigate('/login')}
            className="w-full bg-indigo-600 text-white py-3 rounded-lg font-bold hover:bg-indigo-700 transition"
          >
            Volver al Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500">
      <div className="bg-white shadow-2xl rounded-2xl p-10 w-full max-w-md">
        <h2 className="text-4xl font-extrabold text-center text-gray-800 mb-6">Crear Cuenta</h2>
        <form onSubmit={handleRegister} className="space-y-5">
          {/* ... todos tus inputs se mantienen exactamente igual ... */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Tu nombre completo</label>
            <input name="name" value={form.name} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-indigo-500 focus:outline-none" placeholder="Ej: Juan Pérez" required />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Teléfono</label>
            <input name="phone" value={form.phone} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-indigo-500 focus:outline-none" placeholder="Ej: 3001234567" required />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Correo</label>
            <input type="email" name="email" value={form.email} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-indigo-500 focus:outline-none" placeholder="ejemplo@correo.com" required />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Contraseña</label>
            <input type="password" name="password" value={form.password} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-indigo-500 focus:outline-none" placeholder="********" required />
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className={`w-full text-white py-3 rounded-lg font-semibold transition duration-300 shadow-md flex items-center justify-center ${
              isLoading ? 'bg-indigo-400 cursor-not-allowed' : 'bg-indigo-600 hover:bg-indigo-700'
            }`}
          >
            {isLoading ? 'Procesando registro...' : 'Registrarme'}
          </button>
        </form>

        <p className="text-center text-sm text-gray-600 mt-6">
          ¿Ya tienes cuenta? <a href="/login" className="text-indigo-600 hover:underline font-medium">Inicia sesión</a>
        </p>
      </div>
    </div>
  );
}